<template>
  <YearEditComponent
    :year="new YearDTO()"
    :is-create="true"
    @year-edit-completed="onYearEditCompleted"></YearEditComponent>
</template>
<script setup lang="ts">
import YearEditComponent from '@/components/years/YearEditComponent.vue';
import { YearDTO } from '@/dtos';
import { router } from '@/router/router';
import { useUpdateStatusStore } from '@/stores/modules';
import { SNACKSTATUS } from '@/stores/util';
import { watch } from 'vue';

const emit = defineEmits(['snack']);
const statusStore = useUpdateStatusStore();

const onYearEditCompleted = async () => {};

watch(
  () => statusStore.getStatus(`year-create`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    const key = `year-create`;
    emit('snack', 'Year', value, statusStore.getError(key));
    router.push({ name: 'AdminYearListing' });
  },
);
</script>
